const apiBase = process.env.REACT_APP_API_PROD || "https://api.easyph.com.co/api/";
export const HUB_BASE_URL = apiBase.replace(/\/api\/?$/, "") || "https://api.easyph.com.co";
